import { debugLog, logDataInternally, transformParamsForDebugLog } from "./utils";

export type ID = string | number;
export type GetLogFunc = () => ((...args: any[]) => unknown) | undefined;
export type Params = Record<string, string | number | boolean>;

export abstract class AService {
    public readonly logPrefix: string = 'metrics';
    public readonly serviceName: string = '';

    protected readonly getId: () => string | number | undefined = () => undefined;
    protected readonly getLogFunc: GetLogFunc = () => () => {};

    protected initWithDebug(textToSend: string): boolean {
        const wasInitialized = Boolean(this.getId() && this.getLogFunc());

        debugLog(this.serviceName, `Trying to send ${textToSend}. ${this.serviceName} was initialized: ${wasInitialized}`);
        return wasInitialized;
    }

    protected sendEvent(...args: unknown[]): void {
        this.getLogFunc()?.(...args);
        debugLog(this.serviceName, 'Sending event with data "', ...args, '"');
    }

    protected sendGoalEvent(goalId: string, goalParams?: Params) {
        this.sendEvent(goalId, goalParams);
    }

    public trackGoal(goalId: string, goalParams?: Params, withParamsSavingLog = true, paramsToSave?: Params) {
        if (!this.initWithDebug(`goal: "${goalId}"`)) {
            return;
        }

        this.sendGoalEvent(goalId, goalParams);

        if (withParamsSavingLog) {
            const logParams: [string, string] = [goalId, transformParamsForDebugLog(paramsToSave)];

            logDataInternally(this.logPrefix, this.serviceName, ...logParams);
            debugLog(this.serviceName, `Data: "${logParams.join(' : ')}". Saved internally with "${this.logPrefix}" prefix!`);
        }
    }
}
